import React, {Component, ReactNode, RefObject} from 'react';
import $ from 'jquery';
import {configStore} from 'app/store/global';
import {observer} from 'mobx-react';

interface RowTimeZoneProps {
    timeZoneId: number;
}

@observer
export class RowTimeZone extends Component<RowTimeZoneProps> {
    timeZone: RefObject<HTMLSelectElement> = React.createRef();

    componentDidMount(): void {
        if (configStore.isReady && configStore.TIME_ZONES.length > 0) {
            this.initializeChosen();
        }
    }

    componentDidUpdate(): void {
        if (configStore.isReady && configStore.TIME_ZONES.length > 0) {
            this.initializeChosen();
        }
    }

    initializeChosen = (): void => {
        if (this.timeZone.current) {
            $(this.timeZone.current).chosen({search_contains: true}).trigger('chosen:updated');
        }
    };

    render(): ReactNode {
        const {timeZoneId} = this.props;
        return <div className="field__select profile__timezone-select classical-select">
            <select className="account-chosen-select field__select-chosen"
                name="timezone_id"
                ref={this.timeZone}
                defaultValue={timeZoneId}>
                {configStore.TIME_ZONES.map((zone, i) => <option
                    value={zone.id}
                    key={i}>
                    {zone.name} ({zone.description})
                </option>)}
            </select>
            <div className="field__select-arrow"/>
        </div>;
    }
}
